import React, { Component } from "react";
import { connect } from "react-redux";
import PivotTableUI from 'react-pivottable/PivotTableUI';
import 'react-pivottable/pivottable.css';

class Pivote extends Component {
    constructor(props){
        super(props);
        this.state = props;
    }
    render(){
        return(
            <PivotTableUI
                data={this.props.loads}
                rows={["time"]}
                cols={["company"]}
                onChange={s => this.setState(s)}
                {...this.state}
            />
        )
    }
}

const mapStateToProps = state => {
    return {
        loads: state.loads.data,
        stations: state.stations.data
    }
}

export default connect(mapStateToProps)(Pivote);